module.exports = __webpack_public_path__ + "img/coxa-distal-d.5eb3fa1a.png";